import RejectKycModalAdminPartial from "../../../../partials/admin/menus/kyc/reject-kyc-modal.admin.partial";
import { KycType } from "../../../../types/models/kyc.types";

export function RejectCreatorGstKycAdminScreen() {
  return <RejectKycModalAdminPartial type={KycType.GST} />;
}

export function RejectCreatorPayoutKycAdminScreen() {
  return <RejectKycModalAdminPartial type={KycType.PAYOUT} />;
}
